import { DateTime } from 'luxon';
import { FC } from 'react';
import styled from 'styled-components';

import { humanReadableRunTime } from 'dashboard/lib/workflows/run-stats';
import { WorkflowRun } from 'dashboard/models/workflow-run';
import Card from 'design-system/components/Card/Card';
import { HStack } from 'design-system/components/Stack';
import { DATE_AND_TIME_SECONDS_TZ_FORMAT } from 'lib/constants/luxonFormats';

const StyledCard = styled(Card)`
  flex-grow: 1;
`;
const StyledCardTitle = styled.div`
  color: ${({ theme }) => theme.color.text.secondary};
  font-size: ${({ theme }) => theme.text.paragraph.md};
`;

const StyledCardBody = styled(Card.Body)`
  padding: 0;
`;
interface WorkflowRunOverallStatsProps {
  workflowRun: WorkflowRun;
}

const WorkflowRunOverallStats: FC<WorkflowRunOverallStatsProps> = ({ workflowRun }) => {
  const startTime = DateTime.fromISO(workflowRun['attributes']['created-at']);
  const endTime = DateTime.fromISO(
    workflowRun['attributes']['completed-at'] || workflowRun['attributes']['updated-at'],
  );
  const { durationString } = humanReadableRunTime(startTime, endTime);

  return (
    <HStack>
      <StyledCard>
        <StyledCardTitle>Time</StyledCardTitle>
        <StyledCardBody>{durationString}</StyledCardBody>
      </StyledCard>

      <StyledCard>
        <StyledCardTitle>Start</StyledCardTitle>
        <StyledCardBody>{startTime.toFormat(DATE_AND_TIME_SECONDS_TZ_FORMAT)}</StyledCardBody>
      </StyledCard>

      <StyledCard>
        <StyledCardTitle>End</StyledCardTitle>
        <StyledCardBody>{endTime.toFormat(DATE_AND_TIME_SECONDS_TZ_FORMAT)}</StyledCardBody>
      </StyledCard>
    </HStack>
  );
};

export default WorkflowRunOverallStats;
